import React,{ Component } from 'react'
import QRCode  from 'qrcode.react';
import './index.css'


class AlertQrcode extends Component{
    componentDidMount() {
        document.getElementsByClassName("BsyAlertQrcode")[0] && document.getElementsByClassName("BsyAlertQrcode")[0].addEventListener('click', this.hideAlert);
    }

    hideAlert = () =>{
        if(document.getElementsByClassName("BsyAlertQrcode")[0]){
            document.getElementsByClassName("BsyAlertQrcode")[0].remove()
        }
    }

    render() {
        const {value, size, fgColor, text, css} = this.props
        return <div className="QRcodeContent" style={css}>
            <QRCode
                value = {value}    //value参数为生成二维码的链接
                size = {size}     //二维码的宽高尺寸
                fgColor = {fgColor}  //二维码的颜色
            />
            <div className="QRcodeTip">
                {text}
            </div>
        </div>
    }
}

export default AlertQrcode